<script>
import Layout from '@layouts/main'
import { authMethods } from '@state/helpers'
// import appConfig from '@src/app.config'

export default {
  page: {
    title: 'Forgot Password',
    meta: [{ name: 'description', content: `Forget Password` }],
  },
  components: { Layout },
  data() {
    return {
      email: '',
      authError: null,
      submitted: false
    }
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    forgetPassword() {
      // Reset the authError if it existed.
      this.authError = null
      return this.forgetClient({
        email: this.email,
        // password: this.password,
      })
        .then(response => {
          if(response.status){
            this.submitted=true
          }
        })
        .catch(error => {
          this.authError = error
        })
    },
    goToLogin(){
      this.$router.push(this.$route.query.redirectFrom || { name: 'dashboard' })
    }
  },
}
</script>

<template>
  <Layout>
    <img
      :class="$style.loginLogo"
      src="../../assets/images/power-logo.png"
      alt="power waste logo"
    >
    <form
      :class="$style.form"
      @submit.prevent="forgetPassword"
    >
      <div v-if="submitted">
        <p>
          An email with instructions on how to reset your password has been sent to the email address provided. Please check your spam or junk folder if you don’t see the email in your inbox.
        </p>
        <a 
          class="customLink" 
          href="/login"
        >
          Back to Login
        </a>
      </div>
      <div v-else>
        <BaseInput
          v-model="email"
          name="email"
          placeholder="Enter Email Address"
        />
        <BaseButton
          type="submit"
          :class="$style.loginButton"
        >
          <span>
            Reset Password
          </span>
        </BaseButton>
        <a 
          class="customLink" 
          href="/login"
        >
          Back to Login
        </a>
      </div>

    </form>

  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.loginLogo {
  display: block;
  width: 20%;
  max-width: 200px;
  margin: 0 auto;
  margin-top: calc(55vh - 300px);
}

.loginButton{
  padding: 0.9em;
  margin-bottom: 1.3rem;
  font-family: 'Poppins', sans-serif !important;
  font-size: 16px;
}

input {
  font-family: 'Poppins', sans-serif !important;
}

.form {
  max-width: 600px;
  padding: 60px 70px 60px 70px;
  margin: 0 auto;
  margin-top: 30px;
  text-align: center;
  background-color: $white;
  border-radius: 4px;
  -webkit-box-shadow: 0 0 10px 4px $shadow-black;
  -moz-box-shadow: 0 0 10px 4px $shadow-black;
  box-shadow: 0 0 10px 4px $shadow-black;
}
</style>
